
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/brands/healthplus/oralcare",
      function () {
        return require("private-next-pages/brands/healthplus/oralcare.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/brands/healthplus/oralcare"])
      });
    }
  